export class FnFloatAction{
    id: string;
    textDesc: string;
    imgUrl?: string;
    fnIcon?: string;
    custClass?: string;
}